import cache from './cache';
import cloneSvg from './clone-svg';
var requestQueue = {};
export var clear = function () {
    requestQueue = {};
};
export var queueRequest = function (url, callback) {
    requestQueue[url] = requestQueue[url] || [];
    requestQueue[url].push(callback);
};
export var processRequestQueue = function (url) {
    var _loop_1 = function (i, len) {
        setTimeout(function () {
            if (Array.isArray(requestQueue[url])) {
                var cacheValue = cache.get(url);
                var callback = requestQueue[url][i];
                if (cacheValue instanceof SVGSVGElement) {
                    callback(null, cloneSvg(cacheValue));
                }
                if (cacheValue instanceof Error) {
                    callback(cacheValue);
                }
                if (i === requestQueue[url].length - 1) {
                    delete requestQueue[url];
                }
            }
        }, 0);
    };
    for (var i = 0, len = requestQueue[url].length; i < len; i++) {
        _loop_1(i, len);
    }
};
//# sourceMappingURL=request-queue.js.map